import { useCallback, useEffect, useState } from 'react';
import { api, type FriendsData } from './api';
import { realtime } from './realtime';

/**
 * Amigos y solicitudes de la cuenta, siempre al día.
 *
 * Se recarga cuando el servidor avisa de un cambio (`friends:changed`: te
 * pidieron amistad o te aceptaron) y cada medio minuto mientras se mira, para
 * que el punto de "conectado" no se quede viejo. Sin cuenta devuelve null.
 */
export function useFriends(enabled: boolean): {
  data: FriendsData | null;
  reload: () => Promise<void>;
} {
  const [data, setData] = useState<FriendsData | null>(null);

  const reload = useCallback(async () => {
    if (!enabled) return;
    try {
      const res = await api.get<FriendsData>('/friends');
      setData({ friends: res.friends, incoming: res.incoming, outgoing: res.outgoing });
    } catch {
      /* sin red: se queda lo último que había */
    }
  }, [enabled]);

  useEffect(() => {
    if (!enabled) {
      setData(null);
      return;
    }
    void reload();
    const off = realtime.on((msg) => {
      if (msg.t === 'friends:changed' || msg.t === 'invite') void reload();
    });
    const id = window.setInterval(() => void reload(), 30_000);
    return () => {
      off();
      window.clearInterval(id);
    };
  }, [enabled, reload]);

  return { data, reload };
}
